<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <div class="paper">
                        <h4>Special Incident Reports</h4>
                        <ReportDownloader report-label="SIR Summary Report"
                                          endpoint="Core/Reports/ProgramReports/SIRSummary"
                                          :parameter-schema="ParamsStartEndSubProgram"
                                          report-description="Generates an excel file summarizing the completed special incident reports within the time range.  Summary File contains links to full reports." />
                        

                    </div>
                </div>
                <div class="col-md-4">
                    <div class="paper">
                        <h4></h4>
                        
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="paper">
                        <h4></h4>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';

    //import components
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);

    export default {
        props: [],
        data: function () {
            return {
                
                ParamsStartEndSubProgram: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "All",
                                value: null
                            },
                            {
                                text: "Inland/Desert Wraparound (374)",
                                value: "12E83DA9-E178-4DB2-9077-6097F277443A"
                            },
                            {
                                text: "Inland School Wraparound (394)",
                                value: "446CB3EF-6BEF-4852-8673-C3CAB76F31C9"
                            },
                            {
                                text: "Inland Private Wraparound (504)",
                                value: "6F2DB8BF-8181-48EA-856C-63B12EC45CC8"
                            },
                            {
                                text: "Inland/Desert Foster (104)",
                                value: "CBA01001-B337-425E-BA38-9043F640CF2F"
                            },
                        ]
                    },
                ]
            };
        },
        methods: {
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        computed: {

        },
        components: {
            ReportDownloader
        },
        mounted() {

        }
    }
</script>

<style scoped>
</style>